__turbopack_context__.v({
  "optionLabel": "InlineFilters-Manufacturers-module-scss-module__mzgDMq__optionLabel",
  "options": "InlineFilters-Manufacturers-module-scss-module__mzgDMq__options",
  "search": "InlineFilters-Manufacturers-module-scss-module__mzgDMq__search",
});
